/** Premium venue groups — our most complete coverage cities */
const PREMIUM_CITY_NAMES = new Set(['new york city', 'san francisco bay area', 'washington, dc'])

/** Venue group IDs matching PREMIUM_CITY_NAMES: NYC=1, SF=3, DC=6 */
const PREMIUM_VENUE_GROUP_IDS = new Set([1, 3, 6])

export function isPremiumVenueGroup(vg: { name?: string }): boolean {
  // Boundary data: a venue group can arrive without a name — guard before normalizing.
  if (!vg.name) return false
  return PREMIUM_CITY_NAMES.has(vg.name.toLowerCase())
}

export function isPremiumVenueGroupId(id: number | undefined): boolean {
  if (id === undefined) return false
  return PREMIUM_VENUE_GROUP_IDS.has(id)
}

export interface VenueGroupWithId {
  id: number
  name: string
  venue_group?: unknown
}

/**
 * Categorize venue groups into premium and basic tiers,
 * sorted alphabetically within basic tier.
 */
export function categorizeVenueGroups(venueGroups: VenueGroupWithId[]) {
  const premiumGroups = venueGroups.filter((vg) => isPremiumVenueGroup(vg))
  const basicSorted = venueGroups.filter((vg) => !isPremiumVenueGroup(vg)).sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))

  return { premiumGroups, basicSorted }
}

/**
 * Distribute basic cities into 3 columns (column-first ordering)
 */
export function distributeBasicCitiesIntoColumns(basicSorted: VenueGroupWithId[]) {
  const basicRowCount = Math.ceil(basicSorted.length / 3)
  const basicColumns: VenueGroupWithId[][] = Array.from({ length: 3 }, (_, colIdx) => basicSorted.slice(colIdx * basicRowCount, (colIdx + 1) * basicRowCount)).filter((col) => col.length > 0)
  return basicColumns
}
